var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"process_container"}},[_c('div',{staticClass:"process_header"},[_c('p',[_vm._v("代理流程")])]),_c('div',{staticClass:"process_main"},[_c('img',{attrs:{"src":require("../assets/images/代理流程.png"),"alt":""}})])])
}]

export { render, staticRenderFns }